// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar_sidebar__E9UUQ","spacer":"Sidebar_spacer__1QMag"};